import { styled, Typography, TypographyProps } from '@mui/material'
import React from 'react'

import Tooltip from '@/app/component/atom/tooltip'

type Props = {
  message: string
  variant?: TypographyProps['variant']
  color?: TypographyProps['color']
}

const WhatsappText: React.FC<Props> = ({ message, variant = 'subtitle1', color = 'textPrimary' }) => {
  if (!message) {
    return null
  }

  return (
    <Tooltip title={message}>
      <TruncateText variant={variant} color={color}>
        {message}
      </TruncateText>
    </Tooltip>
  )
}

export const TruncateText = styled(Typography)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitLineClamp: 3,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
})

export default WhatsappText
